import { Component, OnInit } from '@angular/core';
import { Globals } from '../_globals';
import { SiteSessionsService } from 'app/_services/site-sessions.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
})
export class ReportsComponent implements OnInit {
  urlBase = '';

  public showWorkerSessionsReport: boolean = false;
  public showInductionReport: boolean = false;
  public showCompetencyAndTrainingReport: boolean = false;
  public showSiteFormReport: boolean = false;
  public showRecentSiteSessionsCSV: boolean = false;
  public showRestrictionsReport: boolean = false;

  generatedReportData = [];

  constructor(
    public globals: Globals,
    private  siteSessionsService: SiteSessionsService,
  ) {
    switch (globals.user.role) {
      case 3:
        this.urlBase = '/site-owner/';

        this.showWorkerSessionsReport = true;
        this.showSiteFormReport = true;
        this.showInductionReport = true;
        this.showRestrictionsReport = true;
        this.showCompetencyAndTrainingReport = true;
        break;
      case 4:
        this.urlBase = '/support/';

        this.showWorkerSessionsReport = true;
        this.showSiteFormReport = true;
        this.showInductionReport = true;
        this.showCompetencyAndTrainingReport = true;
        this.showRecentSiteSessionsCSV = true;
        this.showRestrictionsReport = true;
        break;
      case 5:
        this.urlBase = '/admin/';

        this.showWorkerSessionsReport = true;
        this.showSiteFormReport = true;
        this.showInductionReport = true;
        this.showCompetencyAndTrainingReport = true;
        this.showRecentSiteSessionsCSV = true;
        this.showRestrictionsReport = true;
        break;
      case 7:
      case 11:
      case 12:
        this.urlBase = '/site-delegate/';

        this.showWorkerSessionsReport = true;
        this.showSiteFormReport = true;
        this.showInductionReport = true;
        this.showRestrictionsReport = true;
        break;
      case 9:
        this.urlBase = '/power-station-owner/';

        this.showCompetencyAndTrainingReport = true;
        break;
      default:
        this.urlBase = '';
    }
  }

  ngOnInit() {}

  public getSiteSessionsBackUp(){
   this.siteSessionsService.getRecentUserSessionfromOfflineBackup();
  }
}
